<template>
  <div class="org">
        <div class="row box">
            <div class="col-6 col-m-12">
                <div class="box-l bg-purple" style="display: flex;align-items: center;">
                    <div style="width:40%;"><img class="boximg" src="../../assets/img/org-bj.png" style="width: 100%;"/></div>
                    <div style="line-height:22px;width:60%;">
                        <h2 style="font-size: 20px;margin-bottom:10px" class="display">HI ！ Welcome</h2>
                        <p class="display" style="font-size:16px;">
                            <span>欢迎回来！尊贵的 </span>
                            <span> {{orgname}} </span>
                            <span> 用户！</span>
                        </p>
                        <p class="display" style="margin-right:20px;">Scholarcy将您的文档转换为可搜索，可共享的摘要抽认卡库，可在任何设备上访问，并带有协作式笔记和注释</p>
                    </div>
                </div>
            </div>
            <div class="col-2 col-m-12 menu">
                <div class="grid-content1">
                    <div class="icon">
                        <img src="../../assets/img/图标3.png" alt="">
                    </div>
                    <div style="line-height:25px">
                        <p style="font-size:15px">子机构账号</p>
                        <p>
                            <span class="total">{{tableData.length}}</span>个
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-2 col-m-12 menu">
                <div class="grid-content">
                    <div class="icon">
                        <img src="../../assets/img/图标2.png" alt="">
                    </div>
                    <div style="line-height:25px">
                        <p style="font-size:15px">套餐总次数</p>
                        <p>
                            <span class="total">{{all_num}}</span>个
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-2 col-m-12">
                <div class="grid-content3">
                    <div class="icon">
                        <img src="../../assets/img/图标.png" alt="">
                    </div>
                    <div style="line-height:25px">
                        <p style="font-size:15px">已分配次数</p>
                        <p>
                            <span class="total">{{allocation_num}}</span>个
                        </p>
                    </div>
                </div>
            </div>
            
        </div>
         <div class="table-box">
                <div style="display:flex;align-items:center;padding: 30px 30px 15px 30px;justify-content: space-between;background-color: white;">
                    <h2>账号管理</h2>
                    <div>
                        
                        <el-button class="button" type="info" style="color:black" @click="resetPassword">批量密码重置</el-button>
                        <el-button class="button" style="background-color:#B094E8;color:white" @click="orgDelUser">批量删除</el-button>
                        <el-button class="button" style="background-color:#F8B3A6;color:white"  @click="update(0)">批量禁用</el-button>
                        <el-button class="button" style="background-color:#E5F4FF;color:#3E7FFC" @click="update(1)">批量启用</el-button>
                        <el-button class="button" style="background-color:#7645EC;color:white" @click="dialogTableVisible = true">创建子账号</el-button>
                    </div>
                </div>
                <div style="padding:0px 30px;background-color:white;">
                    <el-table
                        ref="multipleTable"
                        
                        :header-cell-style="{background:'#EEECED',color:'#606266'}"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%;"
                        @selection-change="handleSelectionChange">
                        <el-table-column
                        type="selection"
                        :selectable="selectableFunc"
                        width="55">
                        </el-table-column>
                        <el-table-column
                        label="机构">
                            <template slot-scope="scope">
                                <span>{{ scope.row.org_username }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                        label="账号"
                        >
                        <template slot-scope="scope">
                                <span>{{ scope.row.username }}</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        label="分配量"
                        >
                        <template slot-scope="scope">
                                <span>{{ scope.row.file_num }}</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        label="使用量"
                        >
                        <template slot-scope="scope">
                                <span>{{ scope.row.succ_file_num }}</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        label="邮箱"
                        show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.email }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" align="center">
                            <template slot-scope="{row}" >
                                <div v-if="row.is_del == '0'">
                                    <span v-if="row.state === 0" style="color:#e34d59">已禁用</span>
                                    <span v-else style="color:#00a870">正常</span>
                                </div>
                                <div v-else>
                                    <span  style="color:#291313">已注销</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="250" class-name="small-padding fixed-width">
                            <template slot-scope="{row}" v-if="row.is_del == '0'">
                                <el-button v-if="row.state === 0"  type="primary" size="mini" plain @click="SubUser(row,1)">开启</el-button>
                                <el-button v-else type="danger"  size="mini" plain @click="SubUser(row,0)">禁用</el-button>
                                <el-popconfirm
                                    title="确认重置此账号密码吗？"
                                    confirm-button-text='确认'
                                    cancel-button-text='取消'
                                    style="margin:0px 10px"
                                    @confirm="resetOrgUser(row)"
                                    >
                                    <el-button slot="reference" style="background-color:#E3EDFF;color:#AD93EA" size="mini" :disabled="row.is_del == '1'">密码重置</el-button>
                                </el-popconfirm>
                                <el-popconfirm
                                    confirm-button-text='确认'
                                    cancel-button-text='取消'
                                    icon="el-icon-info"
                                    icon-color="red"
                                    title="确认删除此账号吗？"
                                    @confirm="delOrgUser(row)"
                                    >
                                    <el-button slot="reference" type="danger" size="mini" :disabled="row.is_del == '1'">删除</el-button>
                                </el-popconfirm>
                            </template>
                            <template slot-scope="{row}" v-else>
                                <el-button v-if="row.state === 0"  type="primary" size="mini" plain @click="SubUser(row,1)">开启</el-button>
                                <el-button v-else type="danger"  size="mini" plain @click="SubUser(row,0)">禁用</el-button>
                                <el-popconfirm
                                    title="确认重置此账号密码吗？"
                                    confirm-button-text='确认'
                                    cancel-button-text='取消'
                                    style="margin:0px 10px"
                                    @confirm="resetOrgUser(row)"
                                    >
                                    <el-button slot="reference" style="background-color:#E3EDFF;color:#AD93EA" size="mini" :disabled="row.is_del == '1'">密码重置</el-button>
                                </el-popconfirm>
                                <el-popconfirm
                                    confirm-button-text='确认'
                                    cancel-button-text='取消'
                                    icon="el-icon-info"
                                    icon-color="red"
                                    title="确认删除此账号吗？"
                                
                                    @confirm="delOrgUser(row)"
                                    >
                                    <el-button slot="reference" type="danger" size="mini" :disabled="row.is_del == '1'">删除</el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="listQuery.page"
                            layout="total, prev, pager, next, jumper"
                            :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
<!-- 创建机构个人账号 -->
<el-dialog title="创建账号" :visible.sync="dialogTableVisible"  width="30%">
    <div class="addClass">
        新创建的机构子账号，初始密码为123456!
    </div>
    <div style="width: 350px;margin-top: 20px">
        <t-form :data="form" :rules="rules" ref="form"  @submit="OrgaddUser" labelWidth="130px" labelAlign="right">
            <t-form-item label="用户名"  name="username">
                <t-input v-model="form.username"></t-input>
            </t-form-item>
            <t-form-item label="密码"  help="不设置密码，则默认123456">
                <t-input type="password" v-model="form.password"></t-input>
            </t-form-item>
            <t-form-item label="邮箱" name="email">
                <t-input v-model="form.email"></t-input>
            </t-form-item>
            <t-form-item label="分配文件上传次数" name="file_num">
                <t-input-number v-model="form.file_num" :min="0"/>
            </t-form-item>
            <t-form-item >
                <t-button theme="primary" type="submit" style="position: absolute;right: 70px;">确认</t-button>
            </t-form-item>
        </t-form>
    </div>
</el-dialog>
  </div>
</template>

<script>
import { Icon } from 'tdesign-icons-vue';
export default {
    name:"org",
    components: {
    Icon,
  },
    data(){
        return{
            newSvgUrl: 'https://tdesign.gtimg.com/icon/default-demo/index.js',
            tableData:[],
            listQuery:{
                page:1,
                size:10,
            },
            total:0,
            form: {
                username: '', // 用户名
                password:"", // 密码
                email:"", // 邮箱
                file_num:null, // 分配文件上传次数
            },
            orgID:[],
            dialogTableVisible:false, // 创建账号 弹窗
            formLabelWidth: '120px',
            // 表单验证
            rules:{
                username:[
                    {required: true,message: '请输入用户名',type: 'error'},
                ],
                email: [
                    { required: true, message: '邮箱必填' },
                    { email: { ignore_max_length: true }, message: '请输入正确的邮箱地址' },
                ],
                file_num:[
                    {required: true,message: '请输入分配文件上传次数',type: 'error'},
                ]
            },
            all_num:0, // 总使用量
            allocation_num:0, // 已分配量
            usage_num:0, // 已使用量
            orgname:localStorage.getItem("organ_name"),
        }
    },
    created(){
        this.orgGetUser() // 获取机构下所有 子账号
        this.OrgFileNum() // 机构查总量 分配量 使用量
    },
    watch: {
        
    },
    methods:{    
    // 机构查总量 分配量 使用量
    OrgFileNum(){
        this.$http({
            url:"api/org_file_num/",
            method:"GET",
        }).then(res=>{
            // 总使用量 all_num
            // 已分配量 allocation_num
            // 已使用量 usage_num
            this.all_num = res.data.all_num
            this.allocation_num = res.data.allocation_num
            this.usage_num = res.data.usage_num
        })
    },   
    // is_del  1是 0否
    selectableFunc(row,index) {
     return row.is_del == 0;
    },
    // 获取机构下所有 子账号
    orgGetUser(){
        this.$http({
            url:"api/org_get_user/",
            method:"GET",
            params:{
                page:this.listQuery.page,
                size:this.listQuery.size,
            }
        }).then(res=>{
            this.tableData = res.data.data.data
            this.total = res.data.data.total
            
        })
    },
    // 复选框 选择的值
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    // 添加个人账号
    OrgaddUser({ validateResult, firstError }) {
            if (validateResult === true) {
                if(!this.form.password){
                    this.$http({
                    url:"api/org_add_user/",
                    method:'POST',
                    data:{
                        username:this.form.username,
                        password:"123456",// 不设置密码,默认123456
                        email:this.form.email,
                        file_num:this.form.file_num
                    }
                }).then(res=>{
                    if(res.data.code == 200){
                        // 成功
                        this.dialogTableVisible = false
                        this.$message.success(res.data.message);
                        this.OrgFileNum()
                        this.orgGetUser()
                        this.form.password = ""
                        this.form.username = ""
                        this.form.email = ""
                        this.form.file_num = null
                    }else{
                        // 失败
                        this.dialogTableVisible = false
                        this.$message.error(res.data.message);
                        this.OrgFileNum()
                        this.orgGetUser()
                        this.form.password = ""
                        this.form.username = ""
                        this.form.email = ""
                        this.form.file_num = null
                    }
                })
                }else{
                    this.$http({
                    url:"api/org_add_user/",
                    method:'POST',
                    data:{
                        username:this.form.username,
                        password:this.form.password,
                        email:this.form.email,
                        file_num:this.form.file_num
                    }
                }).then(res=>{
                    if(res.data.code == 200){
                        // 成功
                        this.dialogTableVisible = false
                        this.$message.success(res.data.message);
                        this.OrgFileNum()
                        this.orgGetUser()
                        this.form.password = ""
                        this.form.username = ""
                        this.form.email = ""
                        this.form.file_num = null
                    }else{
                        // 失败
                        this.dialogTableVisible = false
                        this.$message.error(res.data.message);
                        this.OrgFileNum()
                        this.orgGetUser()
                        this.form.password = ""
                        this.form.username = ""
                        this.form.email = ""
                        this.form.file_num = null
                    }
                })
                }
                
            } else {
                this.$message.warning(firstError);
            }
        },
        
    // 机构账号重置用户账号密码 undefined
    resetPassword(){
        if(this.multipleSelection == undefined || this.multipleSelection.length == 0){
            this.$message.error('请选择账号！！！');
        }else{
            var id = []
            this.multipleSelection.forEach(item => {
                id.push(item.id)
            });
            this.orgID = id
            this.$http({
                url:"api/org_reset_user_password/",
                method:"POST",
                data:{
                    id:this.orgID
                }
            }).then(res=>{
                this.$message({
                    message: res.data.message,
                    type: 'success'
                });
                this.orgGetUser()
                this.$refs.multipleTable.clearSelection();
            }).catch(err=>{
                this.$message({
                    message: res.data.message,
                    type: 'warning'
                });
                this.orgGetUser()
                this.$refs.multipleTable.clearSelection(); 
                
            })
        }
    },
    resetOrgUser(row){
        var userId = []
        userId.push(row.id)
        this.$http({
                url:"api/org_reset_user_password/",
                method:"POST",
                data:{
                    id:userId
                }
            }).then(res=>{
                this.$message({
                    message: res.data.message,
                    type: 'success'
                });
                this.orgGetUser()
            }).catch(err=>{
                this.$message({
                    message: res.data.message,
                    type: 'warning'
                });
                this.orgGetUser()
            })
    },
    // 机构修改个人账号状态
    update(state){
        // 状态 0禁用 1开启
         if(this.multipleSelection == undefined || this.multipleSelection.length == 0){
            this.$message.error('请选择账号！！！');
        }else{
            if(state == 1){
            var id = []
            this.multipleSelection.forEach(item => {
                id.push(item.id)
            });
            this.orgID = id
            this.$http({
                url:"api/org_update_user/",
                method:"POST",
                data:{
                    id:this.orgID,
                    state:1
                }
            }).then(res=>{
                this.$message({
                    message: res.data.message,
                    type: 'success'
                });
                this.orgGetUser()
                this.$refs.multipleTable.clearSelection(); 
                
            }).catch(err=>{
                this.$message({
                    message: res.data.message,
                    type: 'warning'
                });
                this.orgGetUser()
                this.$refs.multipleTable.clearSelection(); 
            })
            }else{
                var id = []
                this.multipleSelection.forEach(item => {
                    id.push(item.id)
                });
                this.orgID = id
                this.$http({
                    url:"api/org_update_user/",
                    method:"POST",
                    data:{
                        id:this.orgID,
                        state:0,
                    }
                }).then(res=>{
                    this.$message({
                        message: res.data.message,
                        type: 'success'
                    });
                    this.orgGetUser()
                    this.$refs.multipleTable.clearSelection(); 
                    
                }).catch(err=>{
                    this.$message({
                        message: res.data.message,
                        type: 'warning'
                    });
                    this.orgGetUser()
                    this.$refs.multipleTable.clearSelection(); 
                })
            }
        }
    },
    delOrgUser(row){
        var userId = []
        userId.push(row.id)
        this.$http({
                url:"api/org_del_user/",
                method:"POST",
                data:{
                    id:userId
                }
            }).then(res=>{
                this.$message({
                    message: res.data.message,
                    type: 'success'
                });
                this.orgGetUser() 
            }).catch(err=>{
                this.$message({
                    message: res.data.message,
                    type: 'warning'
                });
                this.orgGetUser() 
            })
    },
    SubUser(row,state){
        var id = []
        id.push(row.id)
       this.$http({
           url:"api/org_update_user/",
           method:"POST",
           data:{
               "id":id,
               state:state,
           }
       }).then(res=>{
            this.$message({
                    message: res.data.message,
                    type: 'success'
            });
           this.orgGetUser()
       })
    },
    // 机构删除个人账号
    orgDelUser(){
        if(this.multipleSelection == undefined || this.multipleSelection.length == 0){
            this.$message.error('请选择账号！！！');
        }else{
            this.$confirm('删除账号信息的同时会禁用相关账户，您确定要删除该个人账号信息吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                 var id = []
            this.multipleSelection.forEach(item => {
                id.push(item.id)
            });
            this.orgID = id
            this.$http({
                url:"api/org_del_user/",
                method:"POST",
                data:{
                    id:this.orgID
                }
            }).then(res=>{
                this.$message({
                    message: res.data.message,
                    type: 'success'
                });
                this.orgGetUser()
                this.$refs.multipleTable.clearSelection(); 
                
            }).catch(err=>{
                this.$message({
                    message: res.data.message,
                    type: 'warning'
                });
                this.orgGetUser()
                this.$refs.multipleTable.clearSelection(); 
                
            })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
           
        }

    },
    // 分页操作  listQuery.size
    handleSizeChange(val) {
        this.listQuery.size = val
        this.orgGetUser()
    },
    // listQuery.page
    handleCurrentChange(val) {
        this.listQuery.page = val
        this.orgGetUser()
    }


    }
}
</script>

<style lang="scss" scoped>
.row:after {
    content: "";
    clear: both;
    display: block;
}
[class*="col-"] {
    float: left;
    padding: 15px;
}
html {
    font-family: "Lucida Sans", sans-serif;
}
.header {
    background-color: #9933cc;
    color: #ffffff;
    padding: 15px;
}
.menu ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}
.menu li {
    padding: 8px;
    margin-bottom: 7px;
    background-color :#33b5e5;
    color: #ffffff;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}
.menu li:hover {
    background-color: #0099cc;
}
.aside {
    background-color: #33b5e5;
    padding: 15px;
    color: #ffffff;
    text-align: center;
    font-size: 14px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}
.footer {
    background-color: #0099cc;
    color: #ffffff;
    text-align: center;
    font-size: 12px;
    padding: 15px;
}
/* For mobile phones: */
[class*="col-"] {
    width: 100%;
}
@media only screen and (min-width: 600px) {
    /* For tablets: */
    .col-m-12 {width: 8.33%;}
    .col-m-2 {width: 16.66%;}
    .col-m-3 {width: 25%;}
    .col-m-4 {width: 33.33%;}
    .col-m-5 {width: 41.66%;}
    .col-m-6 {width: 50%;}
    .col-m-7 {width: 58.33%;}
    .col-m-8 {width: 66.66%;}
    .col-m-9 {width: 75%;}
    .col-m-10 {width: 83.33%;}
    .col-m-11 {width: 91.66%;}
    .col-m-12 {width: 100%;}
}
@media only screen and (min-width: 768px) {
    /* For desktop: */
    .col-1 {width: 8.33%;}
    .col-2 {width: 16.66%;}
    .col-3 {width: 25%;}
    .col-4 {width: 33.33%;}
    .col-5 {width: 41.66%;}
    .col-6 {width: 50%;}
    .col-7 {width: 58.33%;}
    .col-8 {width: 66.66%;}
    .col-9 {width: 75%;}
    .col-10 {width: 83.33%;}
    .col-11 {width: 91.66%;}
    .col-12 {width: 100%;}
}
// boximg
// @media (max-width: 1499px){
//     .boximg{
//         width: 200px;
//         height: 141px;
//     }
//     .display{
//         display: none;
//         font-size: 13px;
//     }
// }
.addClass{
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background-color: #C3DCF7;
    font-weight: 500;
}
::v-deep .el-checkbox__inner::after {
    box-sizing: content-box;
    content: "";
    border: 1px solid #FFF;
    border-left: 0;
    border-top: 0;
    height: 7px;
    left: 6px;
    position: absolute;
    top: 3px;
    transform: rotate(
45deg) scaleY(0);
    width: 3px;
    transition: transform .15s ease-in .05s;
    transform-origin: center;
}
.el-button--mini {
    font-size: 12px;
    border-radius: 15px;
}
::v-deep .el-table {
    position: relative;
    // overflow: hidden;
    box-sizing: border-box;
    flex: 1;
    width: 100%;
    max-width: 100%;
    font-size: 14px;
    color: #606266;
    border-radius: 15px;
}
::v-deep .el-checkbox__inner {
    display: inline-block;
    position: relative;
    border: 1px solid #0b0b0b;
    border-radius: 4px;
    box-sizing: border-box;
    width: 18px;
    height: 18px;
    background-color: #FFF;
    z-index: 1;
    transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);
    
}
.button{
    margin-bottom: 15px;
    border-radius: 20px;
}
.page{
    margin: 15px 0px;
    text-align: right;
}
.org{
    background-color: #EAEDF2;
    width: 100%;
    // display: flex;
}
.el-pagination {
    white-space: nowrap;
    padding: 25px 5px;
    color: #303133;
    font-weight: 700;
    text-align: center;
}
.box{
    width: 100%;
    padding: 10px 10px;
    background-color: white;
    // height: calc(100vh - 190px);
    .box-l{
        background-color: #EFEFEF;
        height: 220px;
        display: flex;
        align-items: center;
        border-radius: 20px;
    }
    .box-r{
        background-color: #EFEFEF;
        border-radius: 20px;
        height: 220px;
    }
    .box-tabs{
        .row-bg{
            margin-top: 20px;
            .grid-content1{
                background: linear-gradient(to right, #7D24D8, #A56FEB);
                padding: 15px;
                display: flex;
                align-items: center;
                color: white;
                border-radius: 15px;
                .icon{
                    width: 30px;
                    height: 30px;
                    background-color: white;
                    border-radius: 50%;
                    line-height: 37px;
                    text-align: center;
                    margin-right: 10px;
                }
            }
            .grid-content{
                background: linear-gradient(to right, #FF7D37, #FFA16F);
                padding: 15px;
                display: flex;
                align-items: center;
                color: white;
                border-radius: 15px;
                .icon{
                    width: 30px;
                    height: 30px;
                    background-color: white;
                    border-radius: 50%;
                    line-height: 37px;
                    text-align: center;
                    margin-right: 10px;
                }
            }
            .grid-content3{
                background: linear-gradient(to right, #337DF2, #6D9EFD);
                padding: 15px;
                display: flex;
                align-items: center;
                color: white;
                border-radius: 15px;
                .icon{
                    width: 30px;
                    height: 30px;
                    background-color: white;
                    border-radius: 50%;
                    line-height: 37px;
                    text-align: center;
                    margin-right: 10px;
                }
            }
        }
    }
}
.grid-content1{
                background: linear-gradient(to right, #7D24D8, #A56FEB);
                padding: 15px;
                display: flex;
                align-items: center;
                color: white;
                border-radius: 15px;
                .icon{
                    width: 30px;
                    height: 30px;
                    background-color: white;
                    border-radius: 50%;
                    line-height: 37px;
                    text-align: center;
                    margin-right: 10px;
                }
            }
            .grid-content{
                background: linear-gradient(to right, #FF7D37, #FFA16F);
                padding: 15px;
                display: flex;
                align-items: center;
                color: white;
                border-radius: 15px;
                .icon{
                    width: 30px;
                    height: 30px;
                    background-color: white;
                    border-radius: 50%;
                    line-height: 37px;
                    text-align: center;
                    margin-right: 10px;
                }
            }
            .grid-content3{
                background: linear-gradient(to right, #337DF2, #6D9EFD);
                padding: 15px;
                display: flex;
                align-items: center;
                color: white;
                border-radius: 15px;
                .icon{
                    width: 30px;
                    height: 30px;
                    background-color: white;
                    border-radius: 50%;
                    line-height: 37px;
                    text-align: center;
                    margin-right: 10px;
                }
            }
.bg-purple{
    height: 100px;
    // text-align: center;
    .top{
        line-height: 50px;
        .count{
            font-size: 20px;
        }
    }
    .bottom{
        line-height: 50px;
        .title{
            font-size: 16px;
        }
    }
}
.grid-content-two{
    background-color: #FE5454 ;
    color: white;
}
.grid-content-three{
    background-color: #67C2EF;
    color: white;
}
.grid-content-foru{
    background-color: #FBBB3D;
    color: white;
}
::v-deep .el-dialog__body {
    padding: 0px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}


</style>